import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AgentSummary } from "@/model";
import deploymentRepository from "@/repository/deploymentRepository";
import { deploymentQueryKeys } from "./keys";


export const useTraining = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<AgentSummary, AxiosError, {checkout: boolean, description?: string}>({
        mutationKey: ["agent-training", agentId],
        mutationFn: async (params: {checkout: boolean, description?: string}) => {
            const { checkout, description } = params;
            try {
                if (checkout) {
                    await deploymentRepository.checkout(agentId, true);
                }
                const { data } = await deploymentRepository.train(agentId, description);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: deploymentQueryKeys.agentSummary(agentId)
            });
            await queryClient.invalidateQueries({
                queryKey: deploymentQueryKeys.trainingHistoryPageAll(agentId)
            });
        }
    });
};
